export interface ViewerSettings {
  theme: 'light' | 'dark';
  language: 'en' | 'es' | 'fr' | 'de' | 'zh';
  textSize: 'small' | 'medium' | 'large';
}

export const DEFAULT_SETTINGS: ViewerSettings = {
  theme: 'dark',
  language: 'en',
  textSize: 'medium',
};

export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'de', label: 'German' },
  { value: 'zh', label: 'Chinese' },
] as const;

export const TEXT_SIZE_OPTIONS = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
] as const;
